import { Component, OnInit } from '@angular/core';

//  Jquery imports
declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

  openModal() {
    $('#modalAdvertencia').modal('toggle');
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/user/user/user.component.ts